import { Toaster as SonnerToaster } from "sonner"

export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-center"
      theme="dark"
      toastOptions={{
        classNames: {
          toast: "bg-secondary-background text-foreground border-2 border-border neo-shadow",
          actionButton: "bg-main text-[color:var(--color-main-foreground)] border-2 border-border neo-shadow",
          cancelButton: "bg-secondary-background text-foreground border-2 border-border neo-shadow",
        },
      }}
    />
  )
}
